import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { User } from "lucide-react";
import { api } from "@/lib/api";

export const NavAccount = () => {
  const [user, setUser] = useState(null);

  useEffect(() => {
    if (window.location.hash?.includes("session_id=")) return;
    api.get("/auth/me").then(({ data }) => setUser(data)).catch(() => setUser(null));
  }, []);

  if (!user) {
    return (
      <Link
        to="/account"
        data-testid="nav-sign-in-btn"
        className="hidden sm:inline-flex items-center gap-1.5 text-sm font-medium text-[#5C5C5C] hover:text-ink transition-colors duration-300"
      >
        <User size={15} strokeWidth={1.5} /> Sign in
      </Link>
    );
  }

  return (
    <Link to="/account" data-testid="nav-account-link" aria-label="Your account" className="inline-flex items-center">
      {user.picture ? (
        <img src={user.picture} alt={user.name || "Account"} className="w-8 h-8 rounded-full border border-champagne object-cover" />
      ) : (
        <span className="w-8 h-8 rounded-full bg-champagne flex items-center justify-center font-display text-lg text-gold-deep">
          {(user.name || user.email || "A").charAt(0).toUpperCase()}
        </span>
      )}
    </Link>
  );
};
